export const Menu = () => ({
  defaultProps: {
    transitionDuration: 0,
    autoFocus: false,
    disableAutoFocusItem: true,
    disableRestoreFocus: true,
  },
  styleOverrides: {
    paper: {
      borderRadius: 8
    }
  }
});
export const MenuItem = () => ({
  defaultProps: {
    disableRipple: true
  },
  styleOverrides: {
    root: {
      fontSize: 14,
      borderRadius: 8,
      marginInline: 8
    }
  }
});
